import defaultThemeOptions from "./default";

const themeOptions = defaultThemeOptions;

export { themeOptions, defaultThemeOptions };
export { LloydsFontLoader as FontLoader } from "./LloydsFontLoader";
